import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import closeMaxProductQuantityTooltip from '@shopDetails/actions/closeMaxProductQuantityTooltip';
import getIsMaxProductQuantityTooltipClosed from '@shopDetails/selectors/getIsMaxProductQuantityTooltipClosed';
import { getShopMaxProductQuantity } from '@conversion/selectors';
import MaxProductQuantity from './MaxProductQuantity';

const mapStateToProps = createStructuredSelector({
  isTooltipClosed: getIsMaxProductQuantityTooltipClosed,
  quantity: getShopMaxProductQuantity,
});

const mapDispatchToProps = { closeMaxProductQuantityTooltip };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaxProductQuantity);
